import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

class V4CartAddon extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.add);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.add);
  }

  add = async () => {
    const id = this.dataset.variantId;
    if (!id || !this.button || this.button.disabled) return;

    const deferred = CartLinesUpdateEvent.createPromise();
    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: id, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add item');

      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'v4-cart-addon',
          sourceId: this.id,
          itemCount: 1,
          sections: result.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      this.dispatchEvent(new CartErrorEvent({ error: error instanceof Error ? error.message : 'Unable to add item', code: 'INVALID' }));
      this.button.disabled = false;
    } finally {
      this.button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('v4-cart-addon')) customElements.define('v4-cart-addon', V4CartAddon);
